export const getPrefectureName = (prefKey) => {
  if (areaToPrefTable.find((item) => item.key === prefKey)) {
    return areaToPrefTable.find((item) => item.key === prefKey).name
  }
  for (const area of areaToPrefTable) {
    const pref = area.pref_list.find((pref) => pref.key === prefKey)
    if (pref) {
      return pref.name
    }
  }
  return null
}

export const sortPrefLivecamData = (pickup, all) => {
  const pickupList = pickup.map((pickupItem) => {
    const matchedItem = all.find((allItem) => allItem.id === pickupItem.id)
    if (matchedItem) {
      return {
        name: matchedItem.name,
        link: matchedItem.link,
        latest: pickupItem.latest,
        image: pickupItem.image
      }
    }
    return null // 一致しない場合はnullを返す
  }).filter((item) => item !== null) // nullを除外
  const tmpPickupLivecamList = pickupList.sort((a, b) => {
    if (a.citycode < b.citycode) return -1
    if (a.citycode > b.citycode) return 1
    return 0
  })
  let sortPickupLivecamList = tmpPickupLivecamList
  let sortPickupLivecamIds = tmpPickupLivecamList.map((item) => item.id)
  if (tmpPickupLivecamList.length > 12) {
    sortPickupLivecamList = tmpPickupLivecamList.slice(0, 12)
    sortPickupLivecamIds = sortPickupLivecamList.map((item) => item.id)
  }
  const remainingItems = all.filter(
    (allItem) => !sortPickupLivecamIds.some((pickupItem) => pickupItem === allItem.id)
  )
  // 残りの要素をcitycodeで並び替え
  const sortRemainingPreflist = remainingItems.sort((a, b) => {
    if (a.citycode < b.citycode) return -1
    if (a.citycode > b.citycode) return 1
    return 0
  })
  return { sortPickupLivecamList, sortRemainingPreflist }
}

export const getAreaPath = (prefKey) => {
  if (prefKey === 'okinawa') {
    return '/okinawa/'
  }
  for (const area of areaToPrefTable) {
    for (const pref of area.pref_list) {
      if (pref.key === prefKey) {
        return `/${area.key}/${prefKey}/`
      }
    }
  }
}

export const getFullPrefectureName = (prefKey) => {
  const specialPrefectures = {
    東京: '都',
    大阪: '府',
    京都: '府'
  }
  if (areaToPrefTable.find((item) => item.key === prefKey)) {
    return `${areaToPrefTable.find((item) => item.key === prefKey).name}県`
  }
  for (const area of areaToPrefTable) {
    const pref = area.pref_list.find((pref) => pref.key === prefKey)
    if (pref) {
      if (pref.name in specialPrefectures) {
        return `${pref.name}${specialPrefectures[pref.name]}`
      }
      if (pref.name === '道央' || pref.name === '道東' || pref.name === '道南' || pref.name === '道北') {
        return pref.name
      }
      return `${pref.name}県`
    }
  }
  return null
}

export const getJsonData = async (apipath) => {
  try {
    const url = new URL(apipath)
    url.searchParams.set('t', Math.floor(Date.now() / (1000 * 60 * 10)).toString())
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const json = await response.json()
    return json
  } catch (error) {
    console.error('Fetch failed:', error)
    return []
  }
}
